export abstract class Comparable<T> {
    abstract compareTo(other: T): number;
}